




























































































import Vue from "vue";
import { intercomService } from "@/services/IntercomService";
import store from "@/store";

export default Vue.extend({
  async mounted() {
    store.dispatch("syncCurrentUserFomDB");
    await store.dispatch("createWebSocket");
    intercomService.boot(
      (this as any).$intercom,
      this.$store.state.auth.currentUser,
      this.$store.state.retailer.retailer
    );
  },
  methods: {
    closeSnackbar() {
      store.commit("closeSnackbar");
    },
    onResize() {
      this.$store.commit("refreshDeviceMode");
    },
  },
});
